import axios from 'axios'

const url = window.location.origin + '/pai'
// const url = 'http://localhost:9092/ipa'

const service = axios.create({
  baseURL: url,
  timeout: 3600000 // Setting timeout to 1 hour (3600000 ms)
})
service.defaults.timeout = 3600000
service.interceptors.request.use(
  config => {
    if (localStorage.tokenMicros) {
      config.headers.Authorization = localStorage.tokenMicros
    }
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Access-Control-Allow-Credentials'] = 'true'
    config.headers['accept'] = 'application/json'
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(error)
  }
)

export default service
